var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('one-eu-energy-label',{attrs:{"product":_vm.$product}})
}
var staticRenderFns = []

export { render, staticRenderFns }